import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { Formule } from 'src/app/models/formule';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { FormuleFormComponent } from '../../formules/formule-form/formule-form.component';
import { User } from 'src/app/micro-services/user/models/user';
import { UserEleve } from 'src/app/micro-services/user/models/user-eleve';
import { UserFactory } from 'src/app/micro-services/user/user-factory';
import { EUserType } from 'src/app/micro-services/user/enum/e-user-type';
import { Abonnement } from 'src/app/models/abonnement';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
})
export class UserFormComponent implements OnInit {
  userForm: FormGroup;
  @Output() editClientEvent = new EventEmitter<string>();
  @Output() creationUserEvent = new EventEmitter<string>();
  @Input() title: string = "Ajouter un client";
  @Input() isEdit: string;
  @Input() clientString: string;
  client: User;
  userEdited: User;
  formules: Formule[] = [];
  @Input() foo: User;

  constructor(
    private builder: FormBuilder,
    private userService: UserService,
    private apiProvider: ApiProviderService,
    private modalCtrl: ModalController,
    private userFactory: UserFactory,
    private toastr: ToastController

  ) { }

  ngOnInit() {
    let coach = this.userService.getUser();
    let coachId = coach.id;
    this.userForm = this.builder.group({
      userName: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: [''],
      email: ['', [Validators.required, Validators.email]],
    });

    this.apiProvider.getFormulesByCoach(coachId).subscribe(
      (res) => {
        this.formules = res;

        if (this.foo) {
          this.userForm.patchValue({
            userName: this.foo.userName || '',
            phoneNumber: this.foo.phoneNumber,
            firstName: this.foo.firstName,
            lastName: this.foo.name,
            email: this.foo.email,
          });
        }



      },
      (err) => {
        this.formules = [];
      },);



  }


  testType() {
    if (!this.foo) {
      this.validate();
    }
    else {
      this; this.userEdited = this.foo;
      this.userEdited.userName = this.userForm.controls.userName.value;
      this.userEdited.firstName = this.userForm.controls.firstName.value;
      this.userEdited.name = this.userForm.controls.lastName.value;
      this.userEdited.id = this.foo.id;
      this.userEdited.phoneNumber = this.userForm.controls.phoneNumber.value;
      this.userEdited.email = this.userForm.controls.email.value;

      this.apiProvider.editClient(this.userEdited).subscribe(
        (res) => {
          this.foo.userName = this.userForm.controls.userName.value;
          this.foo.phoneNumber = this.userForm.controls.phoneNumber.value;
          this.foo.firstName = this.userForm.controls.firstName.value;
          this.foo.name = this.userForm.controls.lastName.value;
          this.foo.email = this.userForm.controls.email.value;
          this.client = res;
          return this.modalCtrl.dismiss(this.client, 'edit');
        },)
    }
  }

  validate() {
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      return;
    }
    let user: UserEleve = this.userFactory.createFromType(EUserType.Eleve) as UserEleve;
    user.userName = this.userForm.controls.email.value;
    user.phoneNumber = this.userForm.controls.phoneNumber.value;
    user.email = this.userForm.controls.email.value;
    user.firstName = this.userForm.controls.firstName.value;
    user.name = this.userForm.controls.lastName.value;
    user.colorCode = this.generateRandomColor();
    user.isActive = true;

    let register = { ...user, coachId: this.userService.getUser().id }

    this.apiProvider.createUser(register).subscribe(
      (res) => {
        this.client = res
        this.apiProvider.getFormulesByCoach(this.userService.user.id).subscribe({
          next: (res: any[]) => { // Supposons que res est un tableau d'abonnements
            const abonnementSeanceUnique = res.find(abonnement => abonnement.name === "Séance unique");
            if (abonnementSeanceUnique) {
              let abonnement : Abonnement = new Abonnement();
              abonnement.dateDebut = new Date();
              abonnement.recurrence = false;
              abonnement.paiementMod = "";
              abonnement.formuleId = abonnementSeanceUnique.id;
              abonnement.clientId = this.client.id;
              this.apiProvider.newAbonnementClient(abonnement).subscribe({
                next: (res: any) => {
                },
                error: (err: any) => {
                  console.log(err)
                }
              })
            }
          },
          error: (err: any) => {
            console.error(err);
          }
        });

        return this.modalCtrl.dismiss({ ...this.userForm.value, id: res.id }, 'confirm');
      },
      async (err) => {
        let toast;
        if (err.error.message == "User already exists!") {
          toast = await this.toastr.create({
            message: "L'email saisi est déjà lié à un compte.",
            duration: 5000,
            buttons: [
              {
                text: 'Ok',
                role: 'cancel'
              }
            ]
          });
        }else{
          toast = await this.toastr.create({
            message: "Erreur lors de la création du client",
            duration: 2000,
          });
        }

        await toast.present();

      }
    );
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  generateRandomColor(): string {
    // Générer une couleur aléatoire au format hexadécimal
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  //Modal Formule

  async openModalFormule(title: string) {
    const modal = await this.modalCtrl.create({
      component: FormuleFormComponent,
      componentProps: {
        title: title
      }
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.formules.push(data);
    }
  }

}
